import React from 'react';
import { Instagram, MessageCircle, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom'; // Importação necessária para navegação SPA
import { mockData } from '../mock';

const Footer = () => {
  const { footer } = mockData;

  const getSocialIcon = (iconName) => {
    const icons = {
      instagram: <Instagram size={20} />,
      'message-circle': <MessageCircle size={20} />,
      youtube: <Youtube size={20} />
    };
    return icons[iconName];
  };

  return (
    <footer className="bg-black text-gray-400 py-16 border-t border-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          
          {/* Coluna 1: Logo e Social */}
          <div className="space-y-6">
            <div>
              <h2 className="text-2xl font-bold text-white tracking-tighter">UNIFICADOS</h2>
              <p className="text-xs text-orange-500 font-medium tracking-widest uppercase -mt-1">Projeto</p>
            </div>
            <p className="text-sm leading-relaxed">
              Unificando jovens em propósito, comunidade e fé. Um movimento para despertar uma geração.
            </p>
            <div className="flex space-x-4">
              {footer.socials.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  {getSocialIcon(social.icon)}
                </a>
              ))}
            </div>
          </div>

          {/* Coluna 2: Navegação (Links âncora para a Home) */}
          <div>
            <h3 className="text-white font-bold mb-6 underline decoration-orange-500 decoration-2 underline-offset-8">Navegação</h3>
            <ul className="space-y-4 text-sm font-medium">
              <li><Link to="/" className="hover:text-orange-500 transition-colors">Início</Link></li>
              <li><a href="#sobre" className="hover:text-orange-500 transition-colors">Nossa História</a></li>
              <li><a href="#equipe" className="hover:text-orange-500 transition-colors">Equipe</a></li>
              <li><a href="#galeria" className="hover:text-orange-500 transition-colors">Galeria</a></li>
            </ul>
          </div>

          {/* Coluna 3: Suporte (Links para novas páginas) */}
          <div>
            <h3 className="text-white font-bold mb-6 underline decoration-orange-500 decoration-2 underline-offset-8">Suporte</h3>
            <ul className="space-y-4 text-sm font-medium">
              <li><Link to="/loja" className="hover:text-orange-500 transition-colors">Loja Oficial</Link></li>
              <li><a href="#contato" className="hover:text-orange-500 transition-colors">Fale Conosco</a></li>
              <li>
                <Link to="/termos" className="hover:text-orange-500 transition-colors">
                  Termos de Uso
                </Link>
              </li>
              <li>
                <Link to="/privacidade" className="hover:text-orange-500 transition-colors">
                  Política de Privacidade
                </Link>
              </li>
            </ul>
          </div>

          {/* Coluna 4: Newsletter */}
          <div>
            <h3 className="text-white font-bold mb-6 underline decoration-orange-500 decoration-2 underline-offset-8">Fique por dentro</h3>
            <p className="text-sm mb-4">Receba novidades sobre os próximos retiros.</p>
            <form className="flex" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                placeholder="Seu e-mail" 
                className="bg-[#111] border border-gray-800 rounded-l-md px-4 py-2 w-full focus:outline-none focus:border-orange-500 text-white text-sm"
              />
              <button type="submit" className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-r-md transition-colors text-sm font-bold">
                OK
              </button>
            </form>
          </div>
        </div>

        {/* Rodapé Final */}
        <div className="pt-8 border-t border-gray-900 flex flex-col md:flex-row justify-between items-center text-[10px] tracking-wider uppercase text-gray-500">
          <p>{footer.copyright}</p>
          <div className="mt-4 md:mt-0 flex items-center space-x-1">
            <span className="font-bold text-gray-300 uppercase">N9NE DIGITAL</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;